module.exports = __webpack_public_path__ + "static/media/logo.d66b6b70.png";